var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({class:_vm.componentClasses,attrs:{"disabled":_vm.disabled || _vm.loading}},_vm.$listeners),[(_vm.loading)?_c('div',{staticClass:"flex justify-center content-center"},[_c('r-loading')],1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }